import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as Chain } from '../../assets/images/svg/chain.svg';
import themeColors from '../../assets/styles/themeColors';

const ChainIconStyled = styled.div`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  border-radius: 100%;
  background-color: ${themeColors.colorBackgroundPrimaryDark};

  svg {
    circle {
      fill: ${({ cc }) => cc || themeColors.colorBackgroundPrimaryDark};
      stroke: ${({ cs }) => cs || 'none'};
    }

    path {
      stroke: ${({ sc }) => sc || themeColors.colorTextPrimary};
    }
  }
`;

const ChainIcon = (props) => (
  <ChainIconStyled {...props}>
    <Chain />
  </ChainIconStyled>
);

ChainIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  circleColor: PropTypes.string,
  circleStroke: PropTypes.string,
  strokeColor: PropTypes.string,
};

ChainIcon.defaultProps = {
  w: '40px',
  h: '40px',
};

export default ChainIcon;
